module.exports = __webpack_public_path__ + "static/img/product_images_11_h5_zh.3c29c14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_images_11_h5_zh.png
// module id = ub8w
// module chunks = 34